module.exports = __webpack_public_path__ + "static/media/student32.2c566bab.png";